export default {
  GET_PRESIGNED_UPLOAD_URL: {
    url: '/e-general/aws/getUploadSignedUrl',
    method: 'GET'
  },
  GET_COMPANY_STORAGE_UPLOAD_URL: {
    url: '/e-general/company-storage/',
    method: 'POST'
  },
  GET_COMPANY_STORAGE_DOWNLOAD_URL: {
    url: '/e-general/company-storage/',
    method: 'POST'
  },
  GET_PROFILE_PICTURE_UPLOAD_URL: {
    url: '/e-general/company-storage/profile-picture/upload-url',
    method: 'POST'
  },
  GET_PROFILE_PICTURE_DOWNLOAD_URL: {
    url: '/e-general/company-storage/profile-picture/download-url',
    method: 'POST'
  },
  UPLOAD_TERM_OF_SERVICE_FILE: {
    url: '/e-general/company/uploadTerm',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    isMultipart: true
  },
  GET_PRESIGNED_DOWNLOAD_URL: {
    url: '/e-general/aws/getDownloadSignedUrl',
    method: 'GET'
  },
  UPLOAD_SSO_FILE: {
    url: '/e-general/company/upload-cert',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    isMultipart: true
  }
}
